var map = {
	"./background-image.jpg": "./src/assets/background-image.jpg",
	"./check.png": "./src/assets/check.png",
	"./copyBtn.png": "./src/assets/copyBtn.png",
	"./currency.png": "./src/assets/currency.png",
	"./information.png": "./src/assets/information.png",
	"./loading.png": "./src/assets/loading.png",
	"./lock.png": "./src/assets/lock.png",
	"./open.png": "./src/assets/open.png",
	"./sendButton.png": "./src/assets/sendButton.png",
	"./xmark.png": "./src/assets/xmark.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive \\.(mp3%7Cpng%7Cjpe?g)$";